import React from "react";
import Logo from "../../images/zsofi_es_peti_eskuvoje_logo.png";
import { useLanguage } from "../../contexts/LanguageContext";

const Footer = (props) => {
  const { t } = useLanguage();

  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div
                  className="logo widget-title"
                  style={{ textAlign: "center" }}
                >
                  <img
                    src={Logo}
                    alt="logo"
                    style={{
                      maxWidth: "350px",
                      height: "auto",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                </div>
                <p>{t("footer.description")}</p>
              </div>
            </div>
            <div className="col col-xl-8  col-lg-8 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>{t("footer.contactPlanner")}</h3>
                </div>
                <div className="contact-ft">
                  <p>{t("footer.contactPlannerDescription")}</p>
                  <ul>
                    <li>
                      <i className="fi flaticon-phone-call"></i>
                      <a href="tel:+36303299466">+36 30 329 94 66</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
